import { render, staticRenderFns } from "./HealthProfessions.vue?vue&type=template&id=32551e2e&scoped=true"
import script from "./HealthProfessions.vue?vue&type=script&lang=js"
export * from "./HealthProfessions.vue?vue&type=script&lang=js"
import style0 from "./HealthProfessions.vue?vue&type=style&index=0&id=32551e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32551e2e",
  null
  
)

export default component.exports